import type { BoardDocument } from "../shared/schema";

/** A whole-document spacing value, shared by measurement, editing and export. */
export function documentLineHeight(shape: {
  meta?: BoardDocument["meta"];
}): number {
  const value = Number(shape.meta?.calqueLineHeight);
  return Number.isFinite(value) && value >= 1 && value <= 2.5 ? value : 1.5;
}

export function documentTypography(
  shape: Pick<BoardDocument, "props"> & Partial<Pick<BoardDocument, "meta">>,
) {
  return {
    fontFamily: "Arial",
    fontSize: shape.props.fontSize,
    lineHeight: documentLineHeight(shape),
  };
}
